export interface EventBus {
  subscribe: <T = any>(eventName: string, callback: (payload: T) => void) => () => void;
  publish: (eventName: string, payload?: any) => void;
}

type Subscriber = {
  callback: (payload: any) => void;
};

const EventBus = (): EventBus => {
  const subscribers: Record<string, Subscriber[]> = {};

  return {
    subscribe: (eventName, callback) => {
      if (typeof eventName !== 'string') {
        console.error('[EventBus] subscribe invoked with invalid argument: eventName must be a string');
        return () => {};
      }

      if (typeof callback !== 'function') {
        console.error('[EventBus] subscribe invoked with invalid argument: callback must be a function');
        return () => {};
      }

      const subscriber: Subscriber = {
        callback,
      };

      if (!subscribers[eventName]) {
        subscribers[eventName] = [];
      }
      subscribers[eventName].push(subscriber);

      return () => {
        try {
          subscribers[eventName] = subscribers[eventName].filter(s => s !== subscriber);
          if (subscribers[eventName].length === 0) {
            delete subscribers[eventName];
          }
        } catch (error) {
          console.error(`[EventBus] unsubscribe failed for eventName: ${eventName}), error:`, error);
        }
      };
    },

    publish: (eventName, payload) => {
      if (typeof eventName !== 'string') {
        console.error('[EventBus] publish invoked with invalid argument: eventName must be a string');
        return;
      }

      if (subscribers[eventName]) {
        subscribers[eventName].forEach(subscriber => {
          try {
            subscriber.callback(payload);
          } catch (_) {} // eslint-disable-line no-empty
        });
      }
    },
  };
};

export default EventBus;
